import React from "react";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

export const Loader = () => {
    const { t } = useTranslation();
    return <>
        <div className='flex-column align-center justify-center loading-overlay'>
            <div className='padding-left-4 padding-bottom-8'>{t("LOADING_IND")}</div>
            <CircularProgress color="primary" />
        </div>
    </>
}